define('rebrush/components/category/tree',[
	'jquery',
	'cartware/components/_base',
	'cartware/jquery/bem'
], function(
	$,
	Component,
	BEM
) {
	function Tree(node) {
		this.block = BEM.block(node);
		this.headline = this.block.getElements('select-category-headline');

		this.bindEvents();
	}

	Tree.prototype = {
		bindEvents: function() {
			var self = this;
			this.block.on('change', '.' + BEM.buildElementClassname('select', 'select'), function (e) {
				var select = $(this),
					url = select.val();

				self.headline.text(select.find('option:selected').text());

				if (url) {
					window.location = url;
				}

				e.preventDefault();
				return false;
			});
		}
	};

	return Component.create({
		blocks:	null,

		$init: function() {
			this.blocks = BEM.block('layer-category-tree');
			this.blocks.each(function() {
				new Tree(this);
			});
		}
	});
});
